import { render, staticRenderFns } from "./userdetails-component.vue?vue&type=template&id=d0f988ba"
import script from "./userdetails-component.vue?vue&type=script&lang=ts"
export * from "./userdetails-component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports